import React from 'react';
import { Card, Flex, NoWrap, Display } from 'components';
import { moment, sum, reject } from 'helpers';
import { useNamedSelector } from 'helpers';

const progressUtils = {
  getWeightedProgress(progressArray) {
    const weight = progressArray.length ? 1 / progressArray.length : 0;
    return sum(progressArray.map(value => value * weight));
  },
  getActivitiesLabel(completedCount) {
    return completedCount > 1 ? 'activities done' : 'activity done';
  }
};

export function Footer({ id }) {
  const goal = useNamedSelector('goals.details', { id });
  const { activities = [], target_date: targetDate } = goal;

  const totalActivities = activities.length;
  const completedCount = activities.filter(activity => activity.status === 'Completed').length;
  const progress = totalActivities ? reject([completedCount / totalActivities], isNaN) : [];
  const weightedProgress = progressUtils.getWeightedProgress(progress);
  const activitiesLabel = totalActivities ? progressUtils.getActivitiesLabel(completedCount) : '';

  return (
    <Display what={Card.Footer} className="borderless">
      <Card.Progress now={weightedProgress}>
        <Flex>
          {totalActivities > 0 && (
            <NoWrap>
              <b>{`${completedCount}/${totalActivities}`}</b> {activitiesLabel}
            </NoWrap>
          )}
          {targetDate && (
            <Card.Highlight className="pull-right">
              {moment.unix(targetDate).format()}
            </Card.Highlight>
          )}
        </Flex>
      </Card.Progress>
    </Display>
  );
}
